
<article
  class="testimonial-card flex flex-col justify-between"
  :aria-label="`Testimonial by ${testimonial.data.customerName}`"
>
  <header
    class="stars"
    :aria-label="`${testimonial.data.starsRate}‑star rating`"
  >
    <img
      v-for="(star, index) in testimonial.data.starsRate"
      :key="index"
      src="@/images/testimonials/solid-star.svg"
      class="star-icon"
      alt=""
      role="presentation"
    />
  </header>

  <blockquote class="testimonial-quote-container overflow-y-auto">
    <p class="testimonial-quote">{{ testimonial.data.testimonial }}</p>
  </blockquote>

  <footer class="testimonial-author">
    <img
      :src="testimonial.data.customerPhoto.url"
      :alt="`Photo of ${testimonial.data.customerName}`"
      class="avatar"
    />
    <cite class="author-name">{{ testimonial.data.customerName }}</cite>
  </footer>
</article>
